import { useCommodityTypesQuery } from "@/pages/sy/hooks/queries/useCommodityTypesQuery";
import { ErrorModal } from "@dexteel/mesf-core";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useParams } from "react-router-dom";
import { TableCommodityType } from "../components/TableCommodityType";

export const CommodityTypePage = () => {
  const { commodityTypeId } = useParams();
  const [error, setError] = useState("");

  const { data: commodityTypes = [], isLoading } = useCommodityTypesQuery(
    false,
    (err) => setError(err.message),
  );

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} sx={{ m: 0 }}>
          <Paper
            elevation={1}
            sx={{
              width: "100%",
              py: 1.25,
              pb: 2.5,
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableCommodityType
              commodityTypeId={commodityTypeId}
              isLoading={isLoading}
              commodityTypes={commodityTypes}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
